<div class="grid" [style.gap]="tileGap + 'px'" role="listbox" [attr.aria-label]="'Tiles.Procedures' | translate">
	<ng-container *ngFor="let tile of tiles; let i = index; trackBy: trackByTileId">
		<button
			type="button"
			class="tile pallette"
			role="option"
			[attr.data-testid]="'procedure-' + tile.id"
			[attr.aria-label]="tile.title"
			[attr.aria-selected]="isSelected(tile)"
			[ngClass]="{
				'is-selected': isSelected(tile),
				'is-faded': (hasSelection && !isSelected(tile))
			}"
			[disabled]="isDisabled"
			[class]="getTileColor(tile, i)"
			[style.flex-basis]="getTileWidth(i)"
			[attr.item-id]="tile.id"
			[attr.item-title]="tile.title"
			(click)="onTileClick(tile)"
		>
			<ng-container *ngIf="tileTemplate; else defaultTile">
				<ng-container [ngTemplateOutlet]="tileTemplate" [ngTemplateOutletContext]="{ $implicit: tile }"></ng-container>
			</ng-container>
			<ng-template #defaultTile>
				<div class="title">{{ tile.title }}</div>
				<img *ngIf="tile.iconUrl" class="icon" [src]="tile.iconUrl | staticFilesEndpoint" />
			</ng-template>
		</button>
	</ng-container>
</div>
